<template>
  <div>
    <MenuBar />
    <section>
      <div class="container">
        <div class="content-wrapper">
          <div class="box">
            <div class="card-content">
              <div class="content">
                <div class="columns">
                  <div class="column is-8">
                    <h1 class="is-size-3 has-text-weight-semibold">
                      Export your bookmarks
                    </h1>

                    <p>
                      We don't keep you hostage of our service 🙂<br>
                      You can export your bookmarks either as a Netscape Bookmark file format or as a JSON file which you can work with more easily.
                    </p>
                  </div>
                </div>

                <div class="columns has-text-centered">
                  <div class="column is-6">
                    <b-button
                      type="is-primary"
                      size="is-medium"
                      class="extension-link"
                      @click="downloadFile('html')"
                    >
                      Export HTML Format
                    </b-button>
                  </div>
                  <div class="column is-6">
                    <b-button
                      type="is-primary"
                      size="is-medium"
                      class="extension-link"
                      @click="downloadFile('json')"
                    >
                      Export JSON Format
                    </b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import MenuBar from "@/views/_globals/MenuBar.vue"

  export default {
    name: 'Export',
    components: {
      MenuBar
    },
    methods: {
      exportFile(args) {
        return this.$store.dispatch(`imports/exportFile`, args)
      },
      downloadFile(format) {
        this.exportFile(format).then(function(response){
          if (response) {
            let blob = new Blob([response.data.export.fileContents], {type:response.data.export.contentType})
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = response.data.export.fileName
            link.click()
          }
        })
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>
